import { motion } from 'framer-motion';
import { TickCircle, Clock, DocumentText, TrendUp } from '@/components/icons';
import { MetricCard } from '@/components/system';
import { containerVariants, itemVariants } from '../animations';
import type { DashboardStats } from '../types';

type Props = {
    stats: DashboardStats;
};

export const DashboardStatsGrid = ({ stats }: Props) => {
    const statItems = [
        {
            title: 'Total de Laudos',
            value: stats.total,
            icon: DocumentText,
            tone: 'brand' as const,
            iconClassName: 'text-brand',
        },
        {
            title: 'Em Andamento',
            value: stats.inProgress,
            icon: Clock,
            tone: 'warning' as const,
            iconClassName: 'text-warning',
        },
        {
            title: 'Concluídos',
            value: stats.completed,
            icon: TickCircle,
            tone: 'success' as const,
            iconClassName: 'text-success',
        },
        {
            title: 'Este Mês',
            value: stats.thisMonth,
            icon: TrendUp,
            tone: 'info' as const,
            iconClassName: 'text-info',
        },
    ];

    return (
        <>
            <motion.div
                className="grid grid-cols-2 gap-3 md:hidden"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                {statItems.map((item) => {
                    const Icon = item.icon;

                    return (
                        <motion.div
                            key={item.title}
                            variants={itemVariants}
                            className="rounded-2xl border border-border/80 bg-card/95 p-3 shadow-elevation-1"
                        >
                            <div className="flex items-start justify-between gap-2">
                                <div className="min-w-0">
                                    <p className="truncate text-xs font-medium text-muted-foreground">
                                        {item.title}
                                    </p>
                                    <div className="mt-2 text-2xl font-semibold tabular-nums leading-none tracking-tight text-foreground">
                                        {item.value}
                                    </div>
                                </div>
                                <div
                                    className={`flex shrink-0 items-center justify-center ${item.iconClassName}`}
                                >
                                    <Icon className="size-8" variant="Bulk" />
                                </div>
                            </div>
                        </motion.div>
                    );
                })}
            </motion.div>

            <motion.div
                className="hidden gap-6 md:grid md:grid-cols-2 lg:grid-cols-4"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                {statItems.map((item) => (
                    <motion.div key={item.title} variants={itemVariants}>
                        <MetricCard
                            title={item.title}
                            value={item.value}
                            icon={item.icon}
                            tone={item.tone}
                        />
                    </motion.div>
                ))}
            </motion.div>
        </>
    );
};
